import { da, de, en, es, fi, fr, nl, pl, ro, sv } from '@kiku/i18n';
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

export { default as i18n } from 'i18next';

void i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    defaultNS: 'common',
    resources: {
      en: { common: en },
      es: { common: es },
      da: { common: da },
      sv: { common: sv },
      de: { common: de },
      fr: { common: fr },
      nl: { common: nl },
      pl: { common: pl },
      fi: { common: fi },
      ro: { common: ro }
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false
    }
  });
